import { IRenderer, createRenderer } from 'fela';
import friendlyPseudoClass from 'fela-plugin-friendly-pseudo-class';
import placeholderPrefixer from 'fela-plugin-placeholder-prefixer';
import customProperty from './customPropertyPlugin';
import { getDefaultStylesGlobal } from './defaults.styles-global';
import namedKeysPlugin from './namedKeysPlugin';
import { webPreset } from './web-preset';

interface IProps {
  withLegacyDefaultStyles?: boolean;
}

// Atomic names share the `bb-` prefix, so `ww` would collide with the motif wedding website root `.bb-ww`.
// `ad` is Fela's own default filter (ad blockers hide `.bb-ad*`).
const RESERVED_CLASS_NAMES = new Set(['ww']);
const filterClassName = (className: string) =>
  !className.includes('ad') && !RESERVED_CLASS_NAMES.has(className);

const getFelaRenderer = ({ withLegacyDefaultStyles = true }: IProps = {}) => {
  const plugins = [
    // Important! Order of these plugins matters!
    customProperty, // Process our custom and spacing properties first, so that eg. "padding: 4" can be converted into "padding: 16px"
    ...webPreset, // Add px units to all other properties which need it, such as fontSize or width
    friendlyPseudoClass(),
    placeholderPrefixer(),
    namedKeysPlugin,
  ];

  const renderer: IRenderer = createRenderer({
    devMode: process.env.NODE_ENV !== 'production',
    optimizeCaching: true,
    selectorPrefix: 'bb-',
    filterClassName,
    plugins,
  });

  if (withLegacyDefaultStyles) {
    renderer.renderStatic(getDefaultStylesGlobal());
  }

  return renderer;
};

export default getFelaRenderer;
